"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLocationName = exports.useLocationName = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const lodash_1 = require("lodash");
const react_1 = require("react");
function useLocationName(locationId, extraOptions = {}) {
    const options = lodash_1.merge({ variables: { locationId }, context: { locationId } }, extraOptions);
    const res = client_1.useQuery(LOCATION_NAME_QUERY, options);
    return react_1.useMemo(() => { var _a, _b, _c; return (Object.assign(Object.assign({}, res), { data: (_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : null })); }, [res]);
}
exports.useLocationName = useLocationName;
function mockLocationName(variables, { name }) {
    return {
        request: { query: LOCATION_NAME_QUERY, variables },
        result: {
            data: {
                location: {
                    key: '245450',
                    __typename: 'LocationDTO',
                    name,
                },
            },
        },
    };
}
exports.mockLocationName = mockLocationName;
const LOCATION_NAME_QUERY = graphql_tag_1.default `
  query GetLocationNameQuery($locationId: String!) {
    location(locationId: $locationId) {
      key
      name
    }
  }
`;
//# sourceMappingURL=useLocationName.js.map